import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { createHostedPage, postHostedPage } from '@/services/api/resources/chargebee/product/actions';
import { chargebee } from '@/services/chargebee/index';
import { Layout } from '@/services/chargebee/types';
import { fetchUser } from '@/ui/auth/auth';
import { toastAndRedirect } from '@/ui/helpers';
import { t } from '@/ui/i18n/i18n';
import { country, numberSeats, professionalPlan } from '@/services/chargebee/availablePlans';

export const loading = ref(false);
export const hostedPage = ref();
export const hostedPageTask = useTask(
  (data: { planId: string; seats: number; country: string } | undefined) => createHostedPage(data!.planId, data!.seats, data!.country),
  response => {
    hostedPage.value = response.parsed;
  },
);

export const checkout = () => {
  loading.value = true;
  hostedPageTask.run({
    planId: professionalPlan.value!.id,
    seats: numberSeats.value,
    country: country.value,
  });
};

export const openCheckout = async () => {
  if (chargebee.value === null) {
    return;
  }

  chargebee.value.openCheckout({
    hostedPage: async () => hostedPage.value,
    layout: Layout.FULL_PAGE,
    loaded: () => {
      loading.value = false;
    },
    close: () => {
      // TODO: use for HS and mixpanel events
    },
    success: async (hostedPageId: string) => {
      await postHostedPage(hostedPageId)();
      await fetchUser()();
      toastAndRedirect(t('subscription.subscribed'), 'home');
    },
    step: (value: string) => {
      // TODO: use for HS and mixpanel events
    },
    error: (error: string) => {
      // TODO: use for HS and mixpanel events
    },
  });
};
